import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const learnLinks = [
    { to: '/stock-market-fundamentals', label: 'Stock Market Fundamentals' },
    { to: '/investment-basics',         label: 'Investment Basics' },
    { to: '/trading-principles',        label: 'Trading Principles' },
    { to: '/risk-management',           label: 'Risk Management' },
  ];

  const resourceLinks = [
    { to: '/market-analysis',    label: 'Market Analysis' },
    { to: '/trading-platforms',  label: 'Trading Platforms' },
    { to: '/glossary',           label: 'Glossary' },
    { to: '/quiz',               label: 'Knowledge Quiz' },
  ];

  return (
    <footer className="sf-footer">
      <div className="container">
        <div className="row g-4">

          {/* Brand col */}
          <div className="col-lg-4 col-md-12">
            <Link to="/" className="sf-footer-brand">
              <span style={{
                width: 8, height: 8, borderRadius: '50%',
                background: 'var(--green)', flexShrink: 0,
                display: 'inline-block',
              }}></span>
              StckFuture
            </Link>
            <p className="sf-footer-desc">
              Free stock market education for beginners. Learn to invest
              with confidence — no jargon, no sign-up needed.
            </p>
          </div>

          {/* Learn links */}
          <div className="col-lg-3 col-md-6 col-6">
            <h6>Learn</h6>
            <ul className="sf-footer-links">
              {learnLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div className="col-lg-3 col-md-6 col-6">
            <h6>Resources</h6>
            <ul className="sf-footer-links">
              {resourceLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div className="col-lg-2 col-md-12">
            <h6>Ready to invest?</h6>
            <a
              href="https://join.robinhood.com/christm6689"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                background: 'var(--green)',
                color: '#fff',
                fontSize: '0.875rem',
                fontWeight: 500,
                padding: '8px 18px',
                borderRadius: '20px',
                textDecoration: 'none',
                transition: 'background 0.15s',
              }}
            >
              Open Robinhood ↗
            </a>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="sf-disclaimer mt-4">
          <div className="sf-disclaimer-label">Disclaimer</div>
          <p>
            This website is for educational and informational purposes only. The content is not
            intended as a substitute for professional financial advice. All information is for general
            informational purposes only. We do not provide investment recommendations or guidance
            tailored to your specific circumstances. Before investing, consult a qualified financial
            advisor. Investing involves risk, including possible loss of principal. Past performance
            does not indicate future results.
          </p>
        </div>

        <hr className="sf-footer-divider" />

        <div className="sf-footer-bottom">
          <span>© {new Date().getFullYear()} StckFuture. All rights reserved.</span>
          <span>Educational content only · Not financial advice</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;